import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HopeBeginsWithBasket from "./sections/HopeBeginsWithBasket";
import ImpactStatisticsPartners from "./sections/ImpactStatisticsPartners";
import DigitalGrowthEngine from "./sections/DigitalGrowthEngine";
import WhyChooseAnnabriel from "./sections/WhyChooseAnnabriel";
import WhySellWithUs from "./sections/WhySellWithUs";
import TheMbbsPathwayBatches from "./sections/TheMbbsPathwayBatches";
import ServiceAreas from "./sections/ServiceAreas";
import StepByStepInnovation from "./sections/StepByStepInnovation";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import PartnerWithJadav from "./sections/PartnerWithJadav";
import PieDePageCerra from "@/reusable_sections/Footer";
import FloatingWhatsAppButton from "./sections/FloatingWhatsAppButton";
export default function HomePage() {
  return <div>
      <Header />
      <HopeBeginsWithBasket />
      <ImpactStatisticsPartners />
      <DigitalGrowthEngine />
      <WhyChooseAnnabriel />
      <WhySellWithUs />
      <TheMbbsPathwayBatches />
      <ServiceAreas />
      <StepByStepInnovation />
      <FrequentlyAskedQuestions />
      <FloatingWhatsAppButton />
      <PartnerWithJadav />
      <PieDePageCerra />
    </div>;
}